import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { HorizontalSeparatorComponentModule } from '@adaptiva/widgets/horizontal-separator';
import { TableComponentModule } from '@adaptiva/widgets/table';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CpeInfoViewComponentModule } from '../cpe-info-view';
import { CpeWebViewTableComponent } from './cpe-web-view-table.component';

const _widgets = [
	ContainerComponentModule,
	CpeInfoViewComponentModule,
	HorizontalSeparatorComponentModule,
	TableComponentModule,
	TextComponentModule
];

@NgModule({
	imports: [
		_widgets,
		CommonModule,
	],
	declarations: [
		CpeWebViewTableComponent
	],
	exports: [
		CpeWebViewTableComponent
	]
})
export class CpeWebViewTableComponentModule {

}
